import FormulationFilterSkeleton from '@/components/products/components/FormulationFilter/FormulationFilterSkeleton';
import ProductTileSkeleton from '@/components/products/components/ProductTile/ProductTileSkeleton';

import { Box } from '@montugroup/design-system';
import { Grid2 } from '@mui/material';
import CTASection from './CTASection';
import HeadingSection from './HeadingSection';

export function PageSkeleton() {
  const keyFrom = (skeletonIdx: number) => skeletonIdx;
  return (
    <Box maxWidth="xl">
      <HeadingSection />
      <CTASection />
      <Box marginBottom={4}>
        <FormulationFilterSkeleton />
      </Box>
      <Grid2 container spacing={2}>
        {Array.from(Array(3)).map((_, idx) => (
          <Grid2 size={{ xs: 12, sm: 6, lg: 4, xl: 3 }} key={keyFrom(idx)}>
            <ProductTileSkeleton />
          </Grid2>
        ))}
      </Grid2>
    </Box>
  );
}

export default PageSkeleton;
